import React from 'react'
import { useTranslation } from 'react-i18next';

export default function ClassProgressTableHeader(props) {
  const { headerName, subHeaders } = props;

  const {t} = useTranslation("class_progress_report")

  return (
    <div className="classProgressTableHeader">
      <div className="classProgressTableHeaderTitle">{t(headerName)}</div>
      <div className="classProgressTableSubHeaders">
        {subHeaders.map((subHeader, i) => (
          <div key={i} className="classProgressTableSubHeader">{t(subHeader)}</div>
        ))}
      </div>
    </div>
  )
}
